<template>
    <span>
        <remove-item-button title="Remove Property" size="xs" v-b-modal="removeModalID" />
        <modal :id="removeModalID" title="Remove Property" @shown="handleModalShown" @ok="handleRemoveClick"
            >Are you sure you want to remove property {{ propertyName }}?</modal
        >
    </span>
</template>

<script>
    import Modal from '../../generic/modal/modal.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
    import RemoveItemButton from '../../common/reservation-remove-item-button.vue';

    export default {
        mixins: [removeScrollMixin],
        components: {
            Modal,
            RemoveItemButton,
        },
        created() {
            this.propertyName = this.params.data.name;
            this.removeModalID = `modal-remove-property-${this.params.node.rowIndex}`;
        },
        methods: {
            handleModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleRemoveClick() {
                this.params.onRemoveProperty && this.params.onRemoveProperty(this.params.node.rowIndex);
            },
        },
    };
</script>
